import React, { useState } from 'react';
import {
    Card,
    Typography,
    Box,
    Avatar,
    IconButton,
    Tooltip,
    MenuItem,
    Menu
} from '@mui/material';
import { Settings as SettingsIcon, Visibility } from '@mui/icons-material';
import { t } from 'i18next';

const PatientCard = ({ patient, selected, onSelect, navigate }) => {
    const isHighlighted = selected;
    const [menuAnchor, setMenuAnchor] = useState(null);

    const bgColor = isHighlighted ? '#0A579B' : '#ffffff';
    const textColor = isHighlighted ? '#ffffff' : '#0A579B';
    const borderColor = '#0A579B';

    const handleMenuOpen = (event) => {
        event.stopPropagation();
        setMenuAnchor(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleViewPatientPage = () => {
        handleMenuClose();
        navigate('/users/user', {
            state: { user: { ...patient, role_uuid: patient.uuid } }
        });
    };

    const handleOpenMessages = () => {
        handleMenuClose();
        navigate(`/mensagens/${patient.uuid}`);
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => onSelect(patient)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onSelect(patient);
            }}
            style={{ cursor: 'pointer' }}
        >
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: bgColor,
                    border: `2px solid ${borderColor}`,
                    cursor: 'pointer',
                    opacity: !isHighlighted ? 0.9 : 1,
                    transition: '0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.02)',
                        transition: '0.2s ease-in-out'
                    },
                    borderRadius: 3,
                    p: 2
                }}
            >
                <Avatar
                    sx={{
                        width: 64,
                        height: 64,
                        mr: 2,
                        bgcolor: isHighlighted ? '#ffffff' : '#0A579B',
                        color: isHighlighted ? '#0A579B' : '#ffffff'
                    }}
                >
                    {patient.name?.charAt(0)}
                </Avatar>

                <Box
                    flex="1"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                >
                    <Typography variant="h5" sx={{ color: textColor, fontWeight: 600 }}>
                        {patient.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: textColor }}>
                        {isHighlighted
                            ? t('groups.selected')
                            : t('groups.click_to_analyze')}
                    </Typography>
                </Box>

                <Tooltip title={t('groups.options')} arrow>
                    <IconButton sx={{ color: textColor }} onClick={handleMenuOpen}>
                        <Visibility />
                    </IconButton>
                </Tooltip>
                <Menu
                    anchorEl={menuAnchor}
                    open={Boolean(menuAnchor)}
                    onClose={handleMenuClose}
                    onClick={(e) => e.stopPropagation()}
                >
                    <MenuItem onClick={handleViewPatientPage}>
                        {t('groups.see_patient_page')}
                    </MenuItem>
                    <MenuItem onClick={handleOpenMessages}>
                        {t('userPage.openMessages')}
                    </MenuItem>
                </Menu>
            </Card>
        </div>
    );
};

export default PatientCard;
